export var authenticationConstants = {
  lastUpdated: 'Formative.lastUpdated',
  loginToken: 'Formative.loginToken',
  loginTokenExpires: 'Formative.loginTokenExpires',
  refreshToken: 'Formative.refreshToken',
  refreshTokenExpiration: 'Formative.refreshTokenExpiration',
  session: 'Formative.session',
  sessionId: 'Formative.sessionId',
  userId: 'Formative.userId'
};